import React, { ComponentType, FC } from 'react';
import { SectionType } from '@wix/add-panel-common';
import { DynamicMediaSection as DynamicMediaSectionComponent } from '../SectionView/sections/DynamicMediaSection';

import type { AnySection, DynamicMediaSection } from '@wix/add-panel-common';

export interface CategorySearchContentProps {
  query: string;
  resetQuery: () => void;
  getExternalSectionComponent?: (section: AnySection) => ComponentType | null;
}

const dynamicMediaSection: DynamicMediaSection = {
  mediaType: '',
  id: '',
  title: '',
  sectionName: 'CategorySearchContent',
  systemId: 'CategorySearchContent',
  locale: 'en',
  type: SectionType.CategorySearchSection,
  automationId: 'category-search-content',
  groupIds: [],
  conditions: [],
  translations: {
    title: '',
    subNavigationTitle: '',
    presetTitle: '',
  },
  panelDesignIds: [],
  panelDesignOverrideIds: [],
  groupOverrideIds: [],
  showSectionHeader: false,
  noSpaceBeforeSection: true,
  hide: false,
  subNavigationHide: true,
  index: 0,
};

export const CategorySearchContent: FC<CategorySearchContentProps> = ({
  getExternalSectionComponent,
  query,
  resetQuery,
}) => (
  <div data-section-type={dynamicMediaSection.type}>
    <DynamicMediaSectionComponent
      query={query}
      resetQuery={resetQuery}
      section={dynamicMediaSection}
      Component={getExternalSectionComponent?.(dynamicMediaSection) as FC}
    />
  </div>
);
